import React from "react";
import {
    Button,
    Cell,
    List,
    ModalPageHeader,
    NativeSelect,
    Pagination,
    PanelHeaderButton,
    Search,
    SimpleCell,
    Spinner,
    Switch
} from "@vkontakte/vkui";
import {
    Icon16SearchOutline,
    Icon24BrowserBack,
    Icon24ChevronRight
} from "@vkontakte/icons";
import {AdaptivityContext} from "../../assets/constants";
import StandCollectionsApi from "../../api/references/standcollections";
import MainCatalog from "../../catalog/MainCatalog";

class CollectionProductCatalog extends MainCatalog {
    constructor(props) {
        super(props)
        this.state = {
            ...this.state,
            mainSearch: '',
            showSearch: true,
            searchHistory: [],
            groupId: '',
            boundProducts: [],
            groupAction: false,
        }
        this.loadBoundProducts()
    }

    loadBoundProducts = () => {
        const collectionId = this.props.collectionId
        if (!collectionId) {
            return
        }
        StandCollectionsApi.getOne(collectionId).then((response) => {
            if (Number(this.props.collectionId) !== Number(collectionId)) {
                return
            }
            const products = Array.isArray(response.data?.products) ? response.data.products : []
            this.setState({boundProducts: products}, () => this.publishBound(products))
        }).catch(() => {})
    }

    changeCurrentGroup = (groupId) => {
        const next = groupId || ''
        this.setState({
            groupId: next,
            mainSearch: '',
            page: 1,
            items: [],
            loading: true,
            totalItems: 0,
        }, () => this.getItems(''))
    }

    receiveMessage = () => {}

    getSearchUrl = () => {
        return StandCollectionsApi.base_url + StandCollectionsApi.browseProductsPath
    }

    buildSearchBody = (mainSearch, page) => {
        const body = new FormData()
        body.append('group', this.state.groupId || '')
        body.append('sSearch', mainSearch || '')
        body.append('page', page)
        body.append('epp', AdaptivityContext.isMobile ? 10 : 25)
        return body
    }

    applySearchResponse = (response, append) => {
        const results = Array.isArray(response.data.results) ? response.data.results : []
        const items = append ? [...this.state.items, ...results] : results
        this.setState({
            items,
            totalItems: response.data.total,
            totalPages: response.data.totalPages,
            parent_group_id: response.data.parent_group_id || '',
            path: response.data.path || [],
            loading: false,
        })
    }

    persistMainSearch = () => {}

    persistSearchHistory = () => {}

    loadMonitoringItems = () => {}

    saveMonitoringItems = () => {}

    backClick = () => {
        const current = this.state.groupId || ''
        const parentGroupId = this.state.parent_group_id || ''
        if (current !== '' && parentGroupId !== current) {
            this.changeCurrentGroup(parentGroupId)
            return
        }
        if (this.props.onClose) {
            this.props.onClose()
        }
    }

    patchItem = (productId, patch, pendingProductId) => {
        this.setState(state => ({
            pendingProductId: pendingProductId === undefined ? state.pendingProductId : pendingProductId,
            items: (state.items || []).map(row =>
                Number(row.id) === Number(productId) ? {...row, ...patch} : row
            )
        }))
    }

    formatLinkAuthor = (item) => {
        const created = Number(item.linked_created || 0)
        if (!created) {
            return ''
        }
        const stamp = new Date(created * 1000).toLocaleString('ru-RU', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        })
        return item.linked_user_login ? `${item.linked_user_login}, ${stamp}` : stamp
    }

    changeBinding = async (item, checked) => {
        if (!this.props.liveBinding) {
            if (this.props.onToggle) {
                this.props.onToggle(item, checked)
            }
            return
        }
        if (!this.props.collectionId || this.state.pendingProductId || this.state.groupAction) {
            return
        }
        const previous = {
            linked_collection_id: item.linked_collection_id,
            linked_collection_title: item.linked_collection_title,
            linked_created: item.linked_created,
            linked_user_login: item.linked_user_login,
            linked_marked_deleted: item.linked_marked_deleted,
        }
        this.patchItem(item.id, checked ? {
            linked_collection_id: Number(this.props.collectionId),
            linked_collection_title: this.props.collectionTitle || '',
            linked_created: Math.floor(Date.now() / 1000),
            linked_user_login: '',
            linked_marked_deleted: 0,
        } : {
            linked_collection_id: Number(this.props.collectionId),
            linked_collection_title: this.props.collectionTitle || '',
            linked_created: item.linked_created,
            linked_user_login: item.linked_user_login,
            linked_marked_deleted: 1,
        }, item.id)
        try {
            const payload = {
                collection_id: this.props.collectionId,
                product_id: item.id,
            }
            const response = checked
                ? await StandCollectionsApi.bindProduct(payload)
                : await StandCollectionsApi.unbindProduct(payload)
            const data = response.data || {}
            this.patchItem(item.id, checked ? {
                linked_collection_id: Number(this.props.collectionId),
                linked_collection_title: this.props.collectionTitle || '',
                linked_created: data.created || null,
                linked_user_login: data.user_login || '',
                linked_marked_deleted: 0,
            } : {
                linked_collection_id: Number(this.props.collectionId),
                linked_collection_title: this.props.collectionTitle || '',
                linked_created: item.linked_created,
                linked_user_login: item.linked_user_login,
                linked_marked_deleted: 1,
                linked_unbound_at: data.unbound_at || null,
                linked_unbound_user_login: data.unbound_user_login || '',
            }, null)
            if (this.props.onBindingChange) {
                this.props.onBindingChange(data.products_count)
            }
            this.syncBoundProduct(item, checked, data)
        } catch (error) {
            const data = error?.response?.data || {}
            this.patchItem(item.id, data.linked_collection_id ? {
                linked_collection_id: Number(data.linked_collection_id),
                linked_collection_title: data.linked_collection_title || '',
                linked_created: previous.linked_created,
                linked_user_login: previous.linked_user_login,
            } : previous, null)
            window.postMessage({
                type: 'error',
                text: data.error || 'Не удалось изменить привязку',
                timeout: 3000,
                hideSpinner: true,
            })
        }
    }

    publishBound = (products) => {
        if (this.props.onBoundProducts) {
            this.props.onBoundProducts(this.dedupeBoundProducts(products))
        }
    }

    dedupeBoundProducts = (products) => {
        const groups = new Map()
        ;(products || []).forEach((product) => {
            const key = this.pillIdentity(product)
            const group = groups.get(key) || []
            group.push(product)
            groups.set(key, group)
        })
        const fresh = []
        groups.forEach((group) => {
            const active = group.filter(product => Number(product.marked_deleted) !== 1)
            if (active.length) {
                fresh.push(...active)
                return
            }
            const marked = group.slice().sort((left, right) =>
                (Number(right.unbound_at) || 0) - (Number(left.unbound_at) || 0)
            )
            if (marked.length) {
                fresh.push(marked[0])
            }
        })
        return fresh.sort((left, right) =>
            String(left.title || left.name || '').localeCompare(String(right.title || right.name || ''), 'ru')
        )
    }

    pillIdentity = (product) => {
        const title = String(product.title || product.name || '').trim()
        const code = title.match(/\b(V\d+\s+.+?)\s+(?:BY|RU)\s*$/i)
        if (code) {
            return code[1].replace(/\s+/g, ' ').trim().toLowerCase()
        }
        return 'id:' + Number(product.id)
    }

    syncBoundProduct = (item, checked, data) => {
        this.setState(state => {
            const list = Array.isArray(state.boundProducts) ? state.boundProducts : []
            if (!checked) {
                const marked = {
                    marked_deleted: 1,
                    unbound_at: data && data.unbound_at ? data.unbound_at : Math.floor(Date.now() / 1000),
                    unbound_user_login: (data && data.unbound_user_login) || '',
                }
                return {
                    boundProducts: list.map(product => Number(product.id) === Number(item.id)
                        ? {...product, ...marked}
                        : product)
                }
            }
            const restored = {
                id: item.id,
                title: item.name || item.title || '',
                marked_deleted: 0,
                created: data && data.created ? data.created : (item.linked_created || null),
                user_login: (data && data.user_login) || item.linked_user_login || '',
                unbound_at: 0,
                unbound_user_login: '',
            }
            if (list.some(product => Number(product.id) === Number(item.id))) {
                return {
                    boundProducts: list.map(product => Number(product.id) === Number(item.id)
                        ? {...product, ...restored}
                        : product)
                }
            }
            const next = [...list, restored]
            next.sort((left, right) => String(left.title).localeCompare(String(right.title), 'ru'))
            return {boundProducts: next}
        }, () => this.publishBound(this.state.boundProducts))
    }

    changeGroup = async (bind) => {
        if (this.state.groupAction || this.state.pendingProductId || !this.props.collectionId) {
            return
        }
        const title = this.props.collectionTitle || ''
        const search = String(this.state.mainSearch || '').trim()
        const question = bind
            ? (search
                ? `Привязать все найденные товары к коллекции «${title}»?`
                : `Привязать все товары папки и вложенных папок к коллекции «${title}»?`)
            : (search
                ? `Снять все найденные товары с коллекции «${title}»?`
                : `Снять все товары папки и вложенных папок с коллекции «${title}»?`)
        if (!window.confirm(question)) {
            return
        }
        this.setState({groupAction: true})
        try {
            const payload = {
                collection_id: this.props.collectionId,
                group: this.state.groupId,
                sSearch: search,
            }
            const response = bind
                ? await StandCollectionsApi.bindGroup(payload)
                : await StandCollectionsApi.unbindGroup(payload)
            const data = response.data || {}
            if (this.props.onBindingChange) {
                this.props.onBindingChange(data.products_count)
            }
            this.loadBoundProducts()
            this.getItems(this.state.mainSearch, false, this.state.page)
            const text = bind
                ? `Привязано ${Number(data.bound || 0)}. Уже в этой коллекции: ${Number(data.already || 0)}. Пропущено из‑за другой коллекции: ${Number(data.skipped || 0)}.`
                : `Снято ${Number(data.unbound || 0)}`
            window.postMessage({
                type: 'success',
                text,
                timeout: 4000,
                hideSpinner: true,
            })
        } catch (error) {
            const data = error?.response?.data || {}
            window.postMessage({
                type: 'error',
                text: data.error || (bind ? 'Не удалось привязать товары' : 'Не удалось снять товары'),
                timeout: 3000,
                hideSpinner: true,
            })
        } finally {
            this.setState({groupAction: false})
        }
    }

    removeBound = async (product) => {
        if (!this.props.collectionId || this.state.pendingProductId || this.state.groupAction) {
            return
        }
        const previousBound = this.state.boundProducts || []
        const catalogItem = (this.state.items || []).find(row => Number(row.id) === Number(product.id))
        const markedList = (previousBound || []).map(row => Number(row.id) === Number(product.id)
            ? {
                ...row,
                marked_deleted: 1,
                unbound_at: Math.floor(Date.now() / 1000),
                unbound_user_login: row.unbound_user_login || '',
            }
            : row)
        this.setState({
            pendingProductId: product.id,
            boundProducts: markedList,
        }, () => this.publishBound(this.state.boundProducts))
        if (catalogItem) {
            this.patchItem(product.id, {
                linked_collection_id: Number(this.props.collectionId),
                linked_collection_title: this.props.collectionTitle || '',
                linked_marked_deleted: 1,
            }, product.id)
        }
        try {
            const response = await StandCollectionsApi.unbindProduct({
                collection_id: this.props.collectionId,
                product_id: product.id,
            })
            const data = response.data || {}
            if (this.props.onBindingChange) {
                this.props.onBindingChange(data.products_count)
            }
            this.setState(state => ({
                pendingProductId: null,
                boundProducts: (state.boundProducts || []).map(row => Number(row.id) === Number(product.id)
                    ? {
                        ...row,
                        marked_deleted: 1,
                        unbound_at: data.unbound_at || row.unbound_at,
                        unbound_user_login: data.unbound_user_login || row.unbound_user_login || '',
                    }
                    : row),
            }), () => this.publishBound(this.state.boundProducts))
        } catch (error) {
            const data = error?.response?.data || {}
            this.setState({boundProducts: previousBound, pendingProductId: null}, () => {
                this.publishBound(previousBound)
            })
            if (catalogItem) {
                this.patchItem(product.id, {
                    linked_collection_id: catalogItem.linked_collection_id,
                    linked_collection_title: catalogItem.linked_collection_title,
                    linked_created: catalogItem.linked_created,
                    linked_user_login: catalogItem.linked_user_login,
                }, null)
            }
            window.postMessage({
                type: 'error',
                text: data.error || 'Не удалось убрать товар из коллекции',
                timeout: 3000,
                hideSpinner: true,
            })
        }
    }

    renderGroupActions = () => {
        const groupId = this.state.groupId || ''
        if (!this.props.liveBinding || !this.props.collectionId) {
            return null
        }
        if (!groupId || groupId === '00000000-0000-0000-0000-000000000000') {
            return null
        }
        const busy = !!this.state.groupAction || !!this.state.pendingProductId
        return <div style={{display: 'flex', gap: 8, flexWrap: 'wrap', padding: '8px 16px'}}>
            <Button size="s" mode="primary" disabled={busy} onClick={() => this.changeGroup(true)}>
                Выделить все
            </Button>
            <Button size="s" mode="secondary" disabled={busy} onClick={() => this.changeGroup(false)}>
                Снять все
            </Button>
        </div>
    }

    renderBreadcrumbs = () => {
        const path = Array.isArray(this.state.path) ? this.state.path : []
        if (!path.length) {
            return null
        }
        if (AdaptivityContext.isMobile) {
            return <NativeSelect
                value={(path[0] && path[0].external_id) || ''}
                onChange={(event) => this.changeCurrentGroup(event.target.value)}
            >
                {path.slice().reverse().map((item) => (
                    <option key={'crumb-' + item.external_id} value={item.external_id}>{item.name}</option>
                ))}
            </NativeSelect>
        }
        return <div>
            {path.slice().reverse().map((item) => (
                <React.Fragment key={'crumb-' + item.external_id}>
                    <Button size="s" mode="secondary" onClick={() => this.changeCurrentGroup(item.external_id)}>
                        {item.name}
                    </Button>
                    {' / '}
                </React.Fragment>
            ))}
        </div>
    }

    renderGroupPath = (item) => {
        if (!String(this.state.mainSearch || '').trim()) {
            return null
        }
        const path = Array.isArray(item.group_path) ? item.group_path : []
        if (!path.length) {
            return null
        }
        const segments = [{external_id: '', name: 'Каталог'}].concat(path.slice().reverse())
        return <div onClick={(event) => event.stopPropagation()}>
            <small>
                {segments.map((segment, index) => (
                    <React.Fragment key={'product-path-' + item.id + '-' + (segment.external_id || 'root')}>
                        {index > 0 ? ' / ' : null}
                        <span
                            role="link"
                            style={{cursor: 'pointer', color: 'var(--vkui--color_text_accent)'}}
                            onClick={() => this.changeCurrentGroup(segment.external_id)}
                        >
                            {segment.name}
                        </span>
                    </React.Fragment>
                ))}
            </small>
        </div>
    }

    renderProduct = (item) => {
        const own = Number(this.props.collectionId) > 0
            && Number(item.linked_collection_id) === Number(this.props.collectionId)
        const marked = Number(item.linked_marked_deleted) === 1
        const selected = this.props.liveBinding
            ? own && !marked
            : (this.props.selectedIds || []).some((id) => Number(id) === Number(item.id))
        const foreign = item.linked_collection_id && !own && !marked
        const author = selected ? this.formatLinkAuthor(item) : ''
        const searching = String(this.state.mainSearch || '').trim() !== ''
        const rowToggles = !searching && this.props.liveBinding && !foreign

        return <div
            key={'collection-product-' + item.id}
            className="main-catalog_product"
            onClick={() => rowToggles && this.changeBinding(item, !selected)}
            style={{cursor: rowToggles ? 'pointer' : undefined}}
        >
            <div className="main-catalog_product-wrapper">
                <div className={'main-catalog_product-wrapper_name ' + (AdaptivityContext.isMobile ? 'mobile' : 'desktop')}>
                    {item.name}
                    {this.renderGroupPath(item)}
                </div>
                <SimpleCell
                    Component="label"
                    style={{color: foreign ? 'var(--vkui--color_text_secondary)' : undefined}}
                    after={<Switch
                        checked={selected}
                        disabled={!!foreign || !!this.state.pendingProductId || !!this.state.groupAction || !this.props.collectionId}
                        onClick={(event) => event.stopPropagation()}
                        onChange={(event) => {
                            event.stopPropagation()
                            this.changeBinding(item, event.target.checked)
                        }}
                    />}
                >
                    {foreign
                        ? `В коллекции «${item.linked_collection_title}»`
                        : <div>
                            В коллекции
                            {author ? <div><small>{author}</small></div> : null}
                        </div>}
                </SimpleCell>
            </div>
        </div>
    }

    render() {
        const items = Array.isArray(this.state.items) ? this.state.items : []
        const atRoot = !(this.state.groupId)
        const canGoBack = !atRoot || !!this.props.onClose
        return <>
            <ModalPageHeader before={canGoBack ? (
                <PanelHeaderButton onClick={() => this.backClick()}>
                    <Icon24BrowserBack/>
                </PanelHeaderButton>
            ) : null}>
                <div style={{display: 'flex', alignItems: 'center', gap: 8, width: '100%', minWidth: 0}}>
                    <span style={{flexShrink: 0}}>Товары</span>
                    <div style={{flex: '0 0 25%', minWidth: 0}}>
                        <form onSubmit={(event) => {
                            event.preventDefault()
                        }}>
                            <Search
                                autoFocus
                                before={this.state.loading
                                    ? <Spinner size="small" style={{maxWidth: '16px'}}/>
                                    : <Icon16SearchOutline/>}
                                placeholder="Поиск по товарам"
                                autoComplete="off"
                                value={this.state.mainSearch}
                                onChange={this.onSearchChange}
                                onReset={() => this.getItems('')}
                            />
                        </form>
                    </div>
                    <div style={{flex: 1, minWidth: 0, overflowX: 'auto'}}>{this.renderBreadcrumbs()}</div>
                </div>
            </ModalPageHeader>
            {this.renderGroupActions()}
            <List>
                    {!this.state.loading && items.length === 0 &&
                        <Cell>Ничего не найдено</Cell>}
                    {items.map((item) => (
                        String(item.isgroup) === '1'
                            ? <Cell
                                key={'collection-group-' + item.id}
                                after={<Icon24ChevronRight/>}
                                onClick={() => this.changeCurrentGroup(item.external_id)}
                            >
                                {item.name}
                            </Cell>
                            : this.renderProduct(item)
                    ))}
            </List>
            {this.state.loading && <Spinner size="large"/>}
            {this.state.totalPages > 1 &&
                <Pagination
                    currentPage={this.state.page}
                    totalPages={this.state.totalPages}
                    onChange={this.setPage}
                />}
        </>
    }
}

export default CollectionProductCatalog
